import React from 'react';
import {WeaFormItem, WeaInput} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

// 元素类型
class EType extends React.Component {
    state = {
        value: this.props.value
    };

    render() {
        return (
            <WeaFormItem label={getLabel(382251, '元素类型')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <WeaInput value={this.state.value} viewAttr={1}/>
            </WeaFormItem>
        );
    }
}

export default EType;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/base/EType.js